import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CodeBracketIcon, DevicePhoneMobileIcon, PaintBrushIcon, ComputerDesktopIcon } from '@heroicons/react/24/outline';
import AnimatedSection from '../components/AnimatedSection';
import Counter from "../components/StatsCounter";
// import Newsletter from "../components/Newsletter";


const Home = () => {
  const services = [
    {
      icon: CodeBracketIcon,
      title: 'Website Development',
      description: 'Stunning, responsive websites tailored to your brand with cutting-edge technology.',
      image: 'https://images.unsplash.com/photo-1507238691740-187a5b1d37b8'
    },
    {
      icon: DevicePhoneMobileIcon,
      title: 'App Development',
      description: 'Seamless applications for any device, built to perform and delight users.',
      image: 'https://images.pexels.com/photos/50614/pexels-photo-50614.jpeg'
    },
    {
      icon: ComputerDesktopIcon,
      title: 'Software Development',
      description: 'Custom software solutions tailored to your business needs  with a focus on performance and scalability.',
      image: 'https://images.pexels.com/photos/577585/pexels-photo-577585.jpeg'
    }
  ];

  const testimonials = [
    {
      name: "Sarah Johnson",
      role: "CEO, TechStart Inc.",
      content: "CleanTech transformed our digital presence completely. The attention to detail and premium quality exceeded all our expectations.",
      image: "https://images.unsplash.com/photo-1542744095-fcf48d80b0fd",
      rating: 5
    },
    {
      name: "Michael Chen",
      role: "Founder, InnovateLab",
      content: "Working with CleanTech was a game-changer. They delivered a sophisticated platform that perfectly represents our brand.",
      image: "https://images.pexels.com/photos/5668886/pexels-photo-5668886.jpeg",
      rating: 5
    },
    {
      name: "Emily Rodriguez",
      role: "Marketing Director, FutureVision",
      content: "The team's expertise in modern web technologies and design principles is unmatched. Highly recommended!",
      image: "https://images.pexels.com/photos/1181335/pexels-photo-1181335.jpeg",
      rating: 5
    }
  ];

  const stats = [
    { number: "150+", label: "Projects Completed" },
    { number: "98%", label: "Client Satisfaction" },
    { number: "24/7", label: "Support Available" },
    { number: "5+", label: "Years Experience" }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative min-h-screen pt-20 md:pt-24 lg:pt-0 flex items-center justify-center overflow-hidden">
        {/* Background */}
        <div className="absolute inset-0 bg-hero-pattern" />
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1523961131990-5ea7c61b2107)' }}
        />
        
        {/* Animated background elements */}
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
          className="absolute top-20 right-20 w-32 h-32 border border-cleantech-gold/20 rounded-full"
        />
        <motion.div
          animate={{ rotate: -360 }}
          transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
          className="absolute bottom-20 left-20 w-24 h-24 border border-cleantech-gold/30 rounded-full"
        />
        <div className="section-container relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Hero Content */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, ease: "easeOut" }}
              className="text-center lg:text-left"
            >
              <motion.h1
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.2 }}
                className="hero-text text-cleantech-white mb-22"
              >
                Elevate Your{' '}
                <span className="text-gradient animate-gradient bg-300% bg-pos-0">
                  Digital Future
                </span>
              </motion.h1>
              
              <motion.p
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.4 }}
                className="text-xl lg:text-2xl text-white/80 mb-8 max-w-2xl mx-auto lg:mx-0"
              >
                Premium websites, apps, custom software development and designs crafted for success.
                we bring your vision to life with cutting-edge technology and elegant design.
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.6 }}
                className="flex flex-wrap flex-col sm:flex-row gap-4 justify-center lg:justify-start"
              >
                <Link to="/contact" className="btn-primary">
                  Get Started
                 
                </Link>
                <Link to="/portfolio" className="btn-secondary">
                  View Our Work
                </Link>
                {/* <div className="flex flex-wrap gap-4 items-center">
  <Link to="/contact" className="btn-primary group">
    Get Started
    <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform duration-300" />
  </Link>
  
  <Link to="/portfolio" className="btn-secondary inline-flex items-center h-10">
    View Our Work
  </Link>
</div> */}


              </motion.div>
            </motion.div>

            {/* Hero Visual */}
            <motion.div
              initial={{ opacity: 0, x: 50, scale: 0.9 }}
              animate={{ opacity: 1, x: 0, scale: 1 }}
              transition={{ duration: 1, delay: 0.8 }}
              className="relative"
            >
              <div className="relative z-10">
                <img
                  src="/cleantech.png"
                  alt="CleanTech Logo"
                  className="w-full max-w-md mx-auto rounded-2xl shadow-premium gold-glow animate-float"
                />
              </div>
              
              {/* Floating elements */}
              <motion.div
                animate={{ y: [0, -20, 0] }}
                transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                className="absolute -top-6 -left-6 w-24 h-24 glass-card rounded-2xl flex items-center justify-center"
              >
                <CodeBracketIcon className="w-8 h-8 text-cleantech-gold" />
              </motion.div>
              
              <motion.div
                animate={{ y: [0, 20, 0] }}
                transition={{ duration: 3, repeat: Infinity, ease: "easeInOut", delay: 1 }}
                className="absolute -bottom-6 -right-6 w-32 h-20 glass-card rounded-2xl flex items-center justify-center"
              >
                <span className="text-cleantech-gold font-bold">Premium</span>
              </motion.div>
            </motion.div>
          </div>
        </div>

        {/* Scroll indicator */}
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        >
          <div className="w-6 h-10 border-2 border-cleantech-gold/50 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-cleantech-gold rounded-full mt-2"></div>
          </div>
        </motion.div>
      </section>

      {/* Stats Section */}
      <AnimatedSection className="py-16 bg-cleantech-charcoal-light">
        <div className="section-container">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="text-center"
              >
                <div className="text-3xl lg:text-4xl font-bold text-gradient mb-2">
                  {stat.number === "24/7" ? ( <span>{stat.number}</span>) : (
                    <Counter end={stat.number} />
                 )}
                </div>
                <div className="text-white/70">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </AnimatedSection>

      {/* Services Preview */}
      <AnimatedSection className="py-20">
        <div className="section-container">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-cleantech-white mb-6">
              Our <span className="text-gradient">Services</span>
            </h2>
            <p className="text-xl text-white/80 max-w-3xl mx-auto">
              We specialize in creating digital experiences that combine cutting-edge technology 
              with sophisticated design to deliver exceptional results.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => {
              const IconComponent = service.icon;
              return (
                <motion.div
                  key={service.title}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  whileHover={{ y: -10, scale: 1.02 }}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                  className="glass-card p-8 hover:shadow-gold transition-all duration-500 group"
                >
                  <div className="relative mb-6">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-48 object-cover rounded-xl mb-4"
                    />
                    <div className="absolute -bottom-2 -right-2 w-16 h-16 bg-gold-gradient rounded-xl flex items-center justify-center group-hover:animate-glow">
                      <IconComponent className="w-8 h-8 text-cleantech-charcoal" />
                    </div>
                  </div>
                  
                  <h3 className="text-2xl font-bold text-cleantech-white mb-4 group-hover:text-cleantech-gold transition-colors duration-300">
                    {service.title}
                  </h3>
                  <p className="text-white/80">{service.description}</p>
                </motion.div>
              );
            })}
          </div>

          <div className="text-center mt-12">
            <Link to="/services" className="btn-primary">
              View All Services
            </Link>
          </div>
        </div>
      </AnimatedSection>

      {/* Testimonials */}
      <AnimatedSection className="py-20 bg-cleantech-charcoal-light">
        <div className="section-container">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-cleantech-white mb-6">
              Client <span className="text-gradient">Success Stories</span>
            </h2>
            <p className="text-xl text-white/80 max-w-3xl mx-auto">
              Don't just take our word for it. Here's what our clients say about working with CleanTech.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={testimonial.name}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                className="glass-card p-8 hover:shadow-gold transition-all duration-500"
              >
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <span key={i} className="text-cleantech-gold text-xl">★</span>
                  ))}
                </div>
                
                <p className="text-white/90 mb-6 italic">"{testimonial.content}"</p>
                
                <div className="flex items-center">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full mr-4 object-cover"
                  />
                  <div>
                    <div className="font-semibold text-cleantech-white">{testimonial.name}</div>
                    <div className="text-cleantech-gold text-sm">{testimonial.role}</div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </AnimatedSection>
      {/* <Newsletter /> */}


      {/* CTA Section */}
      <AnimatedSection className="py-20">
        <div className="section-container">
          <motion.div
            whileHover={{ scale: 1.02 }}
            className="glass-card p-12 text-center hover:shadow-gold-lg transition-all duration-500"
          >
            <h2 className="text-4xl lg:text-5xl font-bold text-cleantech-white mb-6">
              Ready to Transform Your <span className="text-gradient">Digital Presence?</span>
            </h2>
            <p className="text-xl text-white/80 mb-8 max-w-3xl mx-auto">
              Let's collaborate to create something extraordinary. Our team is ready to bring your vision to life 
              with premium design and cutting-edge technology.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact" className="btn-primary">
                Start Your Project
              </Link>
              <Link to="/portfolio" className="btn-secondary">
                See Our Work
              </Link>
            </div>
          </motion.div>
        </div>
      </AnimatedSection>
    </div>
  );
};

export default Home;